import type { DbNotification } from "@/types/db";

/** Keep stored destinations authoritative; derive routes for legacy linkless rows. */
export function resolveNotificationLink(notification: DbNotification): string | null {
  if (notification.link) return notification.link;

  const entityId = notification.entity_id;

  switch (notification.type) {
    case "project_invite":
    case "project_role_changed":
      return entityId ? `/projects/${encodeURIComponent(entityId)}` : null;

    case "feedback_status_changed": {
      // The entity ID identifies the feedback, not its chat.
      const chatId = notification.metadata?.chat_id;
      return typeof chatId === "string" && chatId.trim()
        ? `/?chat=${encodeURIComponent(chatId)}`
        : null;
    }

    case "workflow_run_completed":
    case "workflow_run_failed":
      return entityId ? `/workflows/sessions/${encodeURIComponent(entityId)}` : null;

    case "announcement_posted":
    case "announcement_incident_update":
    case "announcement_maintenance_update":
      return "/announcements";

    case "agent_review_requested":
    case "agent_review_declined":
    case "agent_review_approved":
    case "agent_review_returned":
    case "agent_reviewed":
    case "agent_score_warning":
    case "agent_demoted":
    case "agent_starter_tests":
      return entityId
        ? `/agents/${encodeURIComponent(entityId)}/view?section=lifecycle`
        : null;

    case "automation_run_ended":
      return "/automations?tab=runs";
    case "automation_schedule_paused":
      return "/automations?tab=schedules";

    default:
      return null;
  }
}
